import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import SEO from '@/components/SEO';

const NotFound = () => {
  return (
    <>
      <SEO
        title="404 - Page Not Found | Gulf Digital"
        description="The page you're looking for doesn't exist."
      />
      
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-warm-white via-warm-gray-50 to-warm-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-2xl mx-auto text-center"
          >
            <div className="mb-8">
              <h1 className="text-9xl font-bold text-brand-maroon mb-4">404</h1>
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Page Not Found</h2>
              <p className="text-lg text-muted-foreground mb-8">
                Sorry, we couldn't find the page you're looking for. It might have been moved, 
                deleted, or the URL might be incorrect.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="bg-brand-maroon hover:bg-brand-maroon-dark">
                <Link to="/">
                  <Home className="mr-2 w-5 h-5" />
                  Go to Homepage
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline">
                <Link to="/contact">
                  <ArrowLeft className="mr-2 w-5 h-5" />
                  Contact Support
                </Link>
              </Button>
            </div>

            <div className="mt-12 pt-12 border-t border-warm-gray-200">
              <h3 className="font-semibold mb-4">Popular Pages</h3>
              <div className="flex flex-wrap justify-center gap-4">
                <Link to="/solutions" className="text-brand-maroon hover:underline">
                  Solutions
                </Link>
                <Link to="/services" className="text-brand-maroon hover:underline">
                  Services
                </Link>
                <Link to="/advisory" className="text-brand-maroon hover:underline">
                  Advisory
                </Link>
                <Link to="/partners" className="text-brand-maroon hover:underline">
                  Partners
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default NotFound;